import { Button } from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { useState } from "react";
import { resetBrowserInstalledState } from "@/utils/startup-watchdog";

export function StartupRecovery() {
  const [isResetting, setIsResetting] = useState(false);

  async function signInAgain() {
    setIsResetting(true);
    await resetBrowserInstalledState();
    window.location.replace("/login");
  }

  return (
    <div
      className="mt-10 flex flex-col items-center gap-3 px-4 text-center"
      data-identifier="startup-recovery"
    >
      <h2 className="font-semibold text-lg">
        <Trans>Nalaganje traja predolgo</Trans>
      </h2>
      <p className="max-w-sm text-default-500 text-sm">
        <Trans>
          Poskusite znova naložiti stran. Če ne pomaga, se ponovno prijavite.
        </Trans>
      </p>
      <div className="flex gap-2">
        <Button
          color="primary"
          data-identifier="startup-recovery-reload"
          isDisabled={isResetting}
          onPress={() => window.location.reload()}
        >
          <Trans>Osveži</Trans>
        </Button>
        <Button
          data-identifier="startup-recovery-sign-in"
          isLoading={isResetting}
          onPress={signInAgain}
          variant="flat"
        >
          <Trans>Ponovno se prijavi</Trans>
        </Button>
      </div>
    </div>
  );
}
